






























































import { Vue, Component, Ref, Watch } from 'vue-property-decorator'
import { QInput } from 'quasar'
import ItemData from 'src/assets/ItemData'
import DialogFullscreen from 'components/modals/Fullscreen.vue'
import PersonAvatar from 'components/account/PersonAvatar.vue'
import MarkdownViewer from 'components/MarkdownViewer.vue'
import api from 'src/assets/api/gql'
import AttendeeSignupCodeFind from 'src/graphql/attendee_signup/AttendeeSignupCodeFind.gql'
import AttendeeSignupCodeJoinCourse from 'src/graphql/attendee_signup/AttendeeSignupCodeJoinCourse.gql'
import AttendeeSignupCodeJoinGroup from 'src/graphql/attendee_signup/AttendeeSignupCodeJoinGroup.gql'
import AttendeeSignupCodeJoinSession from 'src/graphql/attendee_signup/AttendeeSignupCodeJoinSession.gql'

@Component({
  components: {
    DialogFullscreen,
    PersonAvatar,
    MarkdownViewer
  }
})
export default class AttendeeSignupButton extends Vue {
  code = ''
  loading = false
  error = false
  found: Json | null = null

  get foundInfo () {
    if (this.found?.info) {
      const data = new ItemData({ infoTexts: { text: (this.found.info as string[]) } })
      return data.info.text?.getText().toString()
    } else {
      return ''
    }
  }

  @Ref()
  readonly dialog!: DialogFullscreen

  @Ref()
  readonly input!: QInput

  @Watch('code')
  clearFound (code: string) {
    if (!code || code.length < 9) {
      this.found = null
    }
  }

  show () {
    this.code = ''
    this.dialog.show()
  }

  async find () {
    if (this.code.length === 9) {
      this.loading = true
      try {
        const { data: { attendeeSignupCodeFind } } = await api.query({
          query: AttendeeSignupCodeFind,
          variables: {
            code: this.code
          }
        })
        if (attendeeSignupCodeFind) {
          this.loading = false
          if (attendeeSignupCodeFind.attendeeItemId) {
            this.dialog.hide()
            this.$router.replace('/attendee/'+attendeeSignupCodeFind.attendeeItemId)
          } else {
            this.found = attendeeSignupCodeFind
          }
        } else {
          throw new Error()
        }
      } catch (e) {
        this.error = true
        setTimeout(() => {
          this.error = false
          this.code = ''
          this.loading = false
          this.$nextTick(() => {
            this.input.focus()
          })
        }, 500)
      }
    }
  }

  async signup () {
    let itemId: number | null = null
    try {
      this.loading = true
      switch (this.code.substr(-1)) {
        case 'C':
          await this.signupCourse()
          break
        case 'G':
          await this.signupGroup()
          break
        case 'S':
          await this.signupSession()
          break
      }
      this.loading = false
    } catch (e) {
      this.error = true
      setTimeout(() => {
        this.error = false
        this.loading = false
        this.code = ''
        this.$nextTick(() => {
          this.input.focus()
        })
      }, 500)
    }
  }

  async signupCourse () {
    const { data: { attendeeSignupCodeJoinCourse } } = await api.mutate({
      query: AttendeeSignupCodeJoinCourse,
      variables: {
        code: this.code
      }
    })
    const itemId = attendeeSignupCodeJoinCourse?.integer
    if (itemId) {
      this.dialog.hide()
      this.$router.replace('/attendee/'+itemId)
    } else {
      throw new Error()
    }
  }

  async signupGroup () {
    const { data: { attendeeSignupCodeJoinGroup } } = await api.mutate({
      query: AttendeeSignupCodeJoinGroup,
      variables: {
        code: this.code
      }
    })
    const itemId = attendeeSignupCodeJoinGroup?.integer
    if (itemId) {
      this.dialog.hide()
      this.$router.replace('/attendee/'+itemId)
    } else {
      throw new Error()
    }
  }

  async signupSession () {
    const { data: { attendeeSignupCodeJoinSession: { sessionAttendee: attendee } } } = await api.mutate({
      query: AttendeeSignupCodeJoinSession,
      variables: {
        code: this.code
      }
    })
    if (attendee) {
      this.$router.replace(`/attendee/${attendee.responseSession.topicId}/session/${attendee.responseSession.id}/${attendee.id}`)
    }
  }
}
